// extracted by mini-css-extract-plugin
export default {"collapsibleCard":"collapsibleCard_collapsibleCard__C1DSf"};